export default __webpack_public_path__ + "static/media/swipe-down.e7fdec73.png";